import $ from 'jquery';

export const scrollToContact = (e) => {
  e.preventDefault();
  $('html, body').stop().animate({
      scrollTop: document.getElementById('contacts').offsetTop - 80
  }, 500);
};